/**
 * API Configuration Utility
 * 
 * Normalizes the backend URL to prevent double /api paths.
 * Handles all edge cases:
 * - empty env -> /api
 * - https://app.fundelitehq.com -> https://app.fundelitehq.com/api
 * - https://app.fundelitehq.com/ -> https://app.fundelitehq.com/api
 * - https://app.fundelitehq.com/api -> https://app.fundelitehq.com/api
 * - https://app.fundelitehq.com/api/ -> https://app.fundelitehq.com/api
 */

// Normalize backend URL to prevent double /api paths
const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
export const BACKEND_URL = rawBackendUrl.replace(/\/api$/, '');
export const API = `${BACKEND_URL}/api`;

// Development logging (only in dev mode)
if (process.env.NODE_ENV === 'development') {
  console.log('[API Config] Raw REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
  console.log('[API Config] Normalized BACKEND_URL:', BACKEND_URL);
  console.log('[API Config] Final API base:', API);
}

export default API;
